import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const base_url = "https://api.moleculaindonesia.co.id";

export const getBannerMarketing = createAsyncThunk(
  "get/bannerMarketingLanding",
  async (arg, { getState }) => {
    try {
      var config = {
        method: "get",
        url: `${base_url}/api/web/v1/banner?per_page=5&search=banner_marketing&banner_type=general`,
        headers: {
          Accept: "application/json",
        },
      };

      const response = await axios(config);
      const data = await response.data;
      return data;
    } catch (error) {
      //   console.log(error);
      return error;
    }
  }
);

export const getMarketingDetail = createAsyncThunk(
  "get/detailMarketing",
  async (arg, { getState }) => {
    try {
      var config = {
        method: "get",
        url: `${base_url}/api/web/v1/post/slug/marketing`,
        headers: {
          Accept: "application/json",
        },
      };

      const response = await axios(config);
      const data = await response.data;
      return data;
    } catch (error) {
      //   console.log(error);
      return error;
    }
  }
);

export const getBrandLogo = createAsyncThunk(
  "get/brandLogoMarketingLanding",
  async (arg, { getState }) => {
    try {
      var config = {
        method: "get",
        url: `${base_url}/api/web/v1/banner?per_page=99&banner_type=marketing_brand_logo`,
        headers: {
          Accept: "application/json",
        },
      };

      const response = await axios(config);
      const data = await response.data;
      return data;
    } catch (error) {
      //   console.log(error);
      return error;
    }
  }
);

export const getDesignStory = createAsyncThunk(
  "get/designStoryMarketingLanding",
  async (arg, { getState }) => {
    try {
      var config = {
        method: "get",
        url: `${base_url}/api/web/v1/post?per_page=15&post_type=marketing_design_story&search=`,
        headers: {
          Accept: "application/json",
        },
      };

      const response = await axios(config);
      const data = await response.data;
      return data;
    } catch (error) {
      //   console.log(error);
      return error;
    }
  }
);

export const getPortfolio = createAsyncThunk(
  "get/portfolioMarketingLanding",
  async (arg, { getState }) => {
    try {
      var config = {
        method: "get",
        url: `${base_url}/api/web/v1/post?per_page=${arg}&post_type=marketing_portfolio`,
        headers: {
          Accept: "application/json",
        },
      };

      const response = await axios(config);
      const data = await response.data;
      return data;
    } catch (error) {
      //   console.log(error);
      return error;
    }
  }
);

export const getPortfolioById = createAsyncThunk(
  "get/portfolioByIdMarketingLanding",
  async (arg, { getState }) => {
    try {
      var config = {
        method: "get",
        url: `${base_url}/api/web/v1/post/${arg}`,
        headers: {
          Accept: "application/json",
        },
      };

      const response = await axios(config);
      const data = await response.data;
      return data;
    } catch (error) {
      //   console.log(error);
      return error;
    }
  }
);

export const marketingLandingSlice = createSlice({
  name: "marketingLandingSlice",
  initialState: {
    loading_banner: false,
    banner_data: [],

    marketing_loading_detail: false,
    marketing_detail_data: null,

    loading_brand_logo: false,
    brand_logo_data: [],

    loading_design_story: false,
    design_story_data: [],

    loading_portfolio: false,
    portfolio_data: [],

    loading_portfolio_id: false,
    portfolio_id_data: null,
  },
  reducers: {
    addMore: (state) => {},
    deleteItem: (state, index) => {},
  },
  extraReducers: {
    [getBannerMarketing.pending]: (state, { payload }) => {
      state.loading_banner = true;
    },
    [getBannerMarketing.fulfilled]: (state, { payload }) => {
      if (payload.code !== "ERR_BAD_REQUEST") {
        state.banner_data = payload.data;
      } else {
        state.banner_data = [];
      }
      state.loading_banner = false;
    },
    [getBannerMarketing.rejected]: (state, action) => {
      state.loading_banner = false;
    },

    // Detail
    [getMarketingDetail.pending]: (state, { payload }) => {
      state.marketing_loading_detail = true;
    },
    [getMarketingDetail.fulfilled]: (state, { payload }) => {
      if (payload.code !== "ERR_BAD_REQUEST") {
        state.marketing_detail_data = payload.data;
      } else {
        state.marketing_detail_data = null;
      }
      state.marketing_loading_detail = false;
    },
    [getMarketingDetail.rejected]: (state, action) => {
      state.marketing_loading_detail = false;
    },

    // Brand Logo
    [getBrandLogo.pending]: (state, { payload }) => {
      state.loading_brand_logo = true;
    },
    [getBrandLogo.fulfilled]: (state, { payload }) => {
      if (payload.code !== "ERR_BAD_REQUEST") {
        state.brand_logo_data = payload.data;
      } else {
        state.brand_logo_data = [];
      }
      state.loading_brand_logo = false;
    },
    [getBrandLogo.rejected]: (state, action) => {
      state.loading_brand_logo = false;
    },

    // Design Story
    [getDesignStory.pending]: (state, { payload }) => {
      state.loading_design_story = true;
    },
    [getDesignStory.fulfilled]: (state, { payload }) => {
      if (payload.code !== "ERR_BAD_REQUEST") {
        state.design_story_data = payload.data;
      } else {
        state.design_story_data = [];
      }
      state.loading_design_story = false;
    },
    [getDesignStory.rejected]: (state, action) => {
      state.loading_design_story = false;
    },

    // Portfolio
    [getPortfolio.pending]: (state, { payload }) => {
      state.loading_portfolio = true;
    },
    [getPortfolio.fulfilled]: (state, { payload }) => {
      if (payload.code !== "ERR_BAD_REQUEST") {
        state.portfolio_data = payload;
      } else {
        state.portfolio_data = [];
      }
      state.loading_portfolio = false;
    },
    [getPortfolio.rejected]: (state, action) => {
      state.loading_portfolio = false;
    },

    // Portfolio By Id
    [getPortfolioById.pending]: (state, { payload }) => {
      state.loading_portfolio_id = true;
    },
    [getPortfolioById.fulfilled]: (state, { payload }) => {
      if (payload.code !== "ERR_BAD_REQUEST") {
        state.portfolio_id_data = payload.data;
      } else {
        state.portfolio_id_data = null;
      }
      state.loading_portfolio_id = false;
    },
    [getPortfolioById.rejected]: (state, action) => {
      state.loading_portfolio_id = false;
    },
  },
});

// Action creators are generated for each case reducer function
export const { addMore, deleteItem } = marketingLandingSlice.actions;

export default marketingLandingSlice.reducer;
